"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _routerLink = _interopRequireDefault(require("./router-link"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */

/**
 * `Link` styled component.
 */
var Link = _styledComponents["default"].a.attrs(function (_ref) {
  var as = _ref.as,
      colorTheme = _ref.colorTheme,
      disabled = _ref.disabled,
      to = _ref.to;
  return {
    'aria-disabled': disabled,
    as: as || to && _routerLink["default"] || 'a',
    colorTheme: colorTheme || 'primary'
  };
}).withConfig({
  displayName: "link__Link",
  componentId: "sc-1va3scp-0"
})(["border:none;cursor:pointer;outline:none;text-decoration:none;transition:", ";transition-property:border-color,color;", " &[aria-disabled=true]{cursor:default;pointer-events:none;}"], (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.switchProp)('colorTheme', {
  primary: (0, _styledComponents.css)(["color:", ";&:active,&:visited{color:", ";}&:focus-visible{border:2px solid ", ";color:", ";}&:focus,&:hover{color:", ";}&[aria-disabled=true]{color:", ";}"], (0, _styles.color)('primary'), (0, _styles.color)('primary'), (0, _styles.color)('blue400'), (0, _styles.color)('blue600'), (0, _styles.color)('blue600'), (0, _styles.color)('blue200')),
  secondary: (0, _styledComponents.css)(["color:", ";&:active,&:visited{color:", ";}&:focus-visible{border:2px solid ", ";color:", ";}&:focus,&:hover{color:", ";}&[aria-disabled=true]{color:", ";}"], (0, _styles.color)('gray500'), (0, _styles.color)('gray500'), (0, _styles.color)('blue400'), (0, _styles.color)('gray600'), (0, _styles.color)('gray600'), (0, _styles.color)('gray400'))
}));
/**
 * Export `Link` styled component.
 */


var _default = Link;
exports["default"] = _default;